// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reel Card Styling */
.ua-profile-card {
    background: rgba(20, 20, 30, 0.6);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
  }
  
  .ua-profile-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
  }
  
  .ua-profile-card.selected {
    border: 2px solid #667eea !important;
    box-shadow: 0 0 20px rgba(102, 126, 234, 0.5);
  }
  
  /* Central Container Grid */
  .ua-central-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
    padding: 20px;
  }
  
  @media (max-width: 768px) {
    .ua-central-container {
      grid-template-columns: 1fr;
    }
  }
  
  /* Modal Overlay */
  .reel-modal-overlay {
    backdrop-filter: blur(8px);
    animation: fadeIn 0.3s ease;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Reels/Styles/reels-common-settings.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,gDAAgD;EAClD;;EAEA;IACE,oCAAoC;IACpC,6CAA6C;EAC/C;;EAEA,2BAA2B;EAC3B;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,aAAa;EACf;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF;;EAEA,kBAAkB;EAClB;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF","sourcesContent":["/* Reel Card Styling */\n.ua-profile-card {\n    background: rgba(20, 20, 30, 0.6);\n    backdrop-filter: blur(10px);\n    border-radius: 12px;\n    overflow: hidden;\n    transition: all 0.3s ease;\n  }\n  \n  .ua-profile-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);\n  }\n  \n  .ua-profile-card.selected {\n    border: 2px solid #667eea !important;\n    box-shadow: 0 0 20px rgba(102, 126, 234, 0.5);\n  }\n  \n  /* Central Container Grid */\n  .ua-central-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 20px;\n    padding: 20px;\n  }\n  \n  @media (max-width: 768px) {\n    .ua-central-container {\n      grid-template-columns: 1fr;\n    }\n  }\n  \n  /* Modal Overlay */\n  .reel-modal-overlay {\n    backdrop-filter: blur(8px);\n    animation: fadeIn 0.3s ease;\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
